var render, staticRenderFns
import script from "./ChartVerticalBar.vue?vue&type=script&lang=js"
export * from "./ChartVerticalBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8a43e",
  null
  
)

export default component.exports